import _slicedToArray from "@babel/runtime-corejs3/helpers/esm/slicedToArray";
import _valuesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/values";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Date$now from "@babel/runtime-corejs3/core-js/date/now";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import React from "react";
import { Field as FormikField, useFormikContext } from "formik";
import { useQuery } from "@apollo/react-hooks";
import { Option, Select } from "@xo-union/tk-component-fields";
import Spinner from "@xo-union/tk-component-spinner";
import dateTimeFormatted, { defaultFormat } from "./helpers/dateTimeFormatted.js";
import { eventsQuery } from "./graphql.js";
import styles from "./styles.css";
export var formats = ['range', 'short', 'natural', 'weekday', 'verbose', 'ornate'];
var WeddingDateFormat = function WeddingDateFormat() {
  var _eventsData$events$fi, _context;
  var _useQuery = useQuery(eventsQuery),
    eventsData = _useQuery.data,
    eventsLoading = _useQuery.loading;
  var _useFormikContext = useFormikContext(),
    values = _valuesInstanceProperty(_useFormikContext);
  var _ref = values,
    weddingDate = _ref.date;
  var weddingDayTime = eventsData === null || eventsData === void 0 || (_eventsData$events$fi = _findInstanceProperty(_context = eventsData.events).call(_context, function (e) {
    return e.type === 'WeddingDay';
  })) === null || _eventsData$events$fi === void 0 ? void 0 : _eventsData$events$fi.time;
  var defaultDate = React.useMemo(function () {
    var newDate = new Date(_Date$now());
    newDate.setFullYear(newDate.getFullYear() + 1);
    return newDate;
  }, []);
  var date = weddingDate;
  if (date && weddingDayTime) {
    var _context2;
    date = _concatInstanceProperty(_context2 = "".concat(weddingDate, " ")).call(_context2, weddingDayTime);
  }
  var formatOptions = _mapInstanceProperty(formats).call(formats, function (f) {
    return [f, dateTimeFormatted(date || defaultDate, f)];
  });
  if (eventsLoading) return /*#__PURE__*/React.createElement(Spinner, {
    "data-testid": "format-spinner"
  });
  return /*#__PURE__*/React.createElement(FormikField, {
    name: "format",
    label: "Display Format"
  }, function (_ref2) {
    var _ref2$field = _ref2.field,
      name = _ref2$field.name,
      value = _ref2$field.value,
      setFieldValue = _ref2.form.setFieldValue;
    return /*#__PURE__*/React.createElement("span", {
      className: styles.dateFormatDropdown
    }, /*#__PURE__*/React.createElement(Select, {
      name: name,
      value: value || defaultFormat,
      "data-testid": "wedding-date-format",
      label: "Display Format",
      onChange: function onChange(_ref3) {
        var option = _ref3.option;
        return setFieldValue(name, option.value);
      }
    }, _mapInstanceProperty(formatOptions).call(formatOptions, function (_ref4) {
      var _ref5 = _slicedToArray(_ref4, 2),
        key = _ref5[0],
        val = _ref5[1];
      return /*#__PURE__*/React.createElement(Option, {
        value: key,
        key: key,
        "data-testid": "date-option-".concat(key)
      }, val);
    })));
  });
};
export default WeddingDateFormat;